import React from 'react';
import '../../ProductBase.css';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { getMainProductImage } from '../../utils/productUtils';
import { getProductsByType } from '../../services/productService';
import { ProductType } from '../../context/CartContext';

const products = getProductsByType(ProductType.StoreFront);

const ShopStoreFront: React.FC = () => {
  const navigate = useNavigate();
  const enabledProducts = products.filter(product => product.enabled !== false);

  return (
    <div className="shop-container">
      <div className="products-grid">
        {enabledProducts.map((product) => (
          <div key={product.id} className="product-card">
            <h2 className="product-name">{product.name}</h2>
            <div className="product-image-wrapper">
              <img
                src={getMainProductImage(product)}
                alt={product.name}
                className="product-image"
                onClick={() => navigate(`/product/${product.id}`)}
              />
            </div>
            <div className="product-info">
              <p className="product-price">${product.price.toFixed(2)}</p>
              <div className="product-actions">
                <button onClick={() => navigate(`/product/${product.id}`)} className="detail-button">
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopStoreFront;
